import dynamic from 'next/dynamic';
import type { SellerRatingProps } from './SellerRating.typed';
import * as Styled from './SellerRating.styled';
import { VerificationModalProps } from 'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal.typed';
import { pushToDataLayer } from 'services/gtmService';
import { useState } from 'react';
import { MiniRatingSummary } from '../../../../Ratings/MiniRatingSummary/MiniRatingSummary';
import { StarIc } from '@dsch/dd-icons';

const VerificationModal = dynamic<VerificationModalProps>(
  () =>
    import(
      'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal'
    ).then((mod) => mod.VerificationModal),
  { ssr: false },
);

const SellerRating = (props: SellerRatingProps) => {
  const { rating, sellerTypeText, onClickRatings } = props;
  const { average, reviewCount } = rating || {};
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);

  const handleClick = () => {
    setIsVerificationModalOpen(true);
    pushToDataLayer({
      event: 'verification_status_tooltip_click',
      seller_type: sellerTypeText,
    });
  };

  return (
    <>
      <Styled.SellerType data-testid={'seller-type'}>
        <Styled.SellerTypeLink
          isFakeLink
          color="GREY_DARK"
          colorVariant="GREY_DARK"
          fontSize="M16"
          ofType="SECONDARY"
          onClick={handleClick}
        >
          {sellerTypeText}
        </Styled.SellerTypeLink>
        <VerificationModal
          askToClose={() => setIsVerificationModalOpen(false)}
          isOpen={isVerificationModalOpen}
        />
      </Styled.SellerType>

      <MiniRatingSummary
        onClickRatings={onClickRatings}
        average={average}
        reviewCount={reviewCount}
        leadingIcon={
          <StarIc
            height={16}
            width={16}
            color={average ? 'ORANGE' : 'GREY_DARK'}
          />
        }
      />
    </>
  );
};

export { SellerRating };
